// ANGEL FLIGHT — difficulty tiers (scalars only — verbs, not HP-sponging).

import type { Difficulty, DifficultyDef } from '../core/types';

export const DIFFICULTIES: Readonly<Record<Difficulty, DifficultyDef>> =
  Object.freeze({
    recruit: {
      id: 'recruit',
      name: 'Recruit',
      hullMult: 1.4,
      densityMult: 0.8,
      payoutMult: 0.9,
      revealZM: 25, // generous: enemies clear the haze almost at the spawn line
    },
    pilot: {
      id: 'pilot',
      name: 'Pilot',
      hullMult: 1,
      densityMult: 1,
      payoutMult: 1,
      revealZM: 21,
    },
    ace: {
      id: 'ace',
      name: 'Ace',
      hullMult: 0.75,
      densityMult: 1.3,
      payoutMult: 1.25,
      revealZM: 16, // the horde materialises out of the fog uncomfortably close
    },
  } as const);

export function getDifficulty(id: Difficulty): DifficultyDef {
  return DIFFICULTIES[id];
}
